export default "__VITE_ASSET__m1rggs8Y__"